module.exports = __webpack_public_path__ + "img/logo.625fcbf0.svg";